<template>
  <svg class="svg-icon" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <g transform="translate(1 1)" fill="none" fill-rule="evenodd">
      <circle stroke="#363636" cx="7" cy="7" r="7"/>
      <text font-family="PingFangSC-Medium, PingFang SC" font-size="12" font-weight="400" :fill="color">
        <tspan x="5" y="11.5">!</tspan>
      </text>
    </g>
  </svg>
</template>

<script>
  export default {
    name: "IconNotice",
    props: {
      color: {
        default: '#363636',
        type: String,
      },
    },
  }
</script>

<style scoped>

  .svg-icon {
    width: 0.16rem;
    height: 0.16rem;
  }

</style>